import Dexie, { type Table } from 'dexie';

export type RitualStage = 'prime' | 'learn' | 'voice' | 'do' | 'note' | 'done';
export type RitualMode = 'quick' | 'fluent';

export interface LocalRitual {
  id: string;
  user_id: string;
  date: string;
  mode: RitualMode;
  practice_type?: 'inner-work' | 'learning';
  custom_topic?: string;
  virtue?: string;
  topic_id?: string;
  content_key?: string;
  lens_ids?: string[];
  timers?: Record<string, number>;
  ended: boolean;
  current_stage?: RitualStage;
  stages?: Record<string, unknown>;
  oracle_metrics?: Record<string, unknown>;
  completed_at?: string;
  created_at: string;
  updated_at: string;
}

export class LocalRitualDB extends Dexie {
  rituals!: Table<LocalRitual, string>;

  constructor() {
    super('LocalRitualDB');
    this.version(1).stores({
      rituals: 'id, user_id, date, ended, created_at',
    });
  }
}

let localDb: LocalRitualDB | null = null;

/**
 * Get the local database instance
 * Exported so it can be used by other modules if needed
 */
export function getLocalDb(): LocalRitualDB {
  if (!localDb) {
    if (typeof window !== 'undefined') {
      localDb = new LocalRitualDB();
    } else {
      // Fallback or throw for server-side
      // While Dexie can run in Node with fake indexedDB, we usually shouldn't need it on server here.
      // We'll return a dummy or allow it to fail later if methods are called.
      // However, to satisfy type safety allow returning null in internal logic or throw?
      // Since the return type is LocalRitualDB, we must return one or throw.
      // Let's create it anyway, Dexie might just warn if no indexedDB.
      localDb = new LocalRitualDB();
    }
  }
  return localDb;
}
